<template>
	<div class="page page-bg-render" data-name="ccm-self-study">
		<f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        자율 학습
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>

		<div class="toolbar tabbar toolbar-bottom">
			<div class="toolbar-inner">
				<a href="#tab-1" class="tab-link tab-link-active">월간 커리큘럼 현황</a>
				<a href="#tab-2" class="tab-link ">학습 커리큘럼</a>				
			</div>
		</div>
		<div class="tabs">
			<div class="page-content tab  tab-active" id="tab-1">											

				<div class="block-title">					
					<button class="button button-outline float-left" style="width:unset; line-height: 1;">
						<i class="f7-icons" style="vertical-align:middle">plus</i>
						<span style="vertical-align:middle"> 커리큘럼 등록</span>
					</button>					
				</div>
				<study-calendar></study-calendar>
			</div>
			<div class="page-content tab" id="tab-2">	
				<div class="swiper-container swiper-init">
					<div class="swiper-wrapper">	
						<div class="swiper-slide">	
							<div class="block-title "><span class="vertical-align-middle">소단원 : 01. 삼각형의 성질</span></div>					
							<div class="block-title">
								<span class="vertical-align-middle">개념학습</span>
								<span class="badge color-primary vertical-align-middle">3</span>
							</div>
							<div class="list">
								<ul>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 개념학습1</div>
												<div class="item-after"><span class="badge color-gray">결과보기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 개념학습2</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 개념학습3</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
								</ul>
							</div>
							<div class="block-title">
								<span class="vertical-align-middle">기본 다잡기</span>
								<span class="badge color-primary vertical-align-middle">4</span>
							</div>
							<div class="list">
								<ul>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 기본학습1</div>
												<div class="item-after"><span class="badge color-gray">결과보기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 기본학습2</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 기본학습3</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 기본학습4</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
								</ul>
							</div>
							<div class="block-title">
								<span class="vertical-align-middle">유형 다지기</span>
								<span class="badge color-primary vertical-align-middle">4</span>
							</div>
							<div class="list">
								<ul>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 유형학습1</div>
												<div class="item-after"><span class="badge color-gray">결과보기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 유형학습2</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 유형학습3</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 유형학습4</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
								</ul>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="block-title "><span class="vertical-align-middle">소단원 : 02. 평행 사변형</span></div>
							<div class="block-title">
								<span class="vertical-align-middle">개념학습</span>
								<span class="badge color-primary vertical-align-middle">3</span>
							</div>
							<div class="list">
								<ul>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 개념학습1</div>
												<div class="item-after"><span class="badge color-gray">결과보기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 개념학습2</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 개념학습3</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
								</ul>
							</div>
							<div class="block-title">
								<span class="vertical-align-middle">기본 다잡기</span>
								<span class="badge color-primary vertical-align-middle">4</span>
							</div>
							<div class="list">
								<ul>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 기본학습1</div>
												<div class="item-after"><span class="badge color-gray">결과보기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 기본학습2</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 기본학습3</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 기본학습4</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
								</ul>
							</div>
							<div class="block-title">
								<span class="vertical-align-middle">유형 다지기</span>
								<span class="badge color-primary vertical-align-middle">4</span>
							</div>
							<div class="list">
								<ul>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 유형학습1</div>
												<div class="item-after"><span class="badge color-gray">결과보기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 유형학습2</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 유형학습3</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
									<li>
										<a href="#" class="item-link">
											<div class="item-content item-inner">
												<div class="item-title">오늘 유형학습4</div>
												<div class="item-after"><span class="badge color-orange">학습하기</span></div>
											</div>
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		
		</div>

	</div>
	
</template>

<script>
import StudyCalendar  from '../../../components/calendar/study-calendar';
import { f7 } from 'framework7-vue';
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js'
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';
export default {
	components: {
		StudyCalendar
	},
	data() {
		 return {

		 }
	},
	mounted() {

	},
	methods: {

	}
}
</script>